var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPhoneRoundedBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83953 6.60972C3.7787 8.19972 4.1812 10.9006 6.88953 13.6097C7.47883 14.2058 8.13065 14.7366 8.8337 15.1931M5.11537 4.11305C6.2762 2.95222 8.12787 3.10805 8.86537 4.42972L9.4062 5.39805C9.8937 6.27305 9.69787 7.41972 8.92953 8.18888C8.92953 8.18888 7.9962 9.12138 9.68787 10.8122C11.377 12.5014 12.3104 11.5706 12.3104 11.5706C13.0795 10.8014 14.227 10.6056 15.1012 11.0931L16.0704 11.6347C17.3912 12.3714 17.547 14.223 16.3862 15.3847C15.6887 16.0814 14.8337 16.6247 13.8895 16.6597C13.0261 16.6895 12.1634 16.582 11.3337 16.3414",
    stroke: "#374655",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPhoneRoundedBroken);
export default __webpack_public_path__ + "static/media/solar_phone-rounded-broken.989839a1f8812b48c0c67bb8e31d7754.svg";
export { ForwardRef as ReactComponent };